import { create } from '@terminal/utils/store/createStore';

interface ScheduleDrawerState {
  isOpen: boolean;
  editingTaskId: string | null;
  initialQuery: string | null;
  /** Incremented on every open/openForEdit so consumers can use it as a `key`
   *  to remount the drawer form with fresh state. */
  drawerKey: number;
}

interface ScheduleDrawerActions {
  open: (query?: string) => void;
  openForEdit: (taskId: string) => void;
  close: () => void;
}

type ScheduleDrawerStore = ScheduleDrawerState & ScheduleDrawerActions;

export const useScheduleDrawer = create<ScheduleDrawerStore>((set, get) => ({
  isOpen: false,
  editingTaskId: null,
  initialQuery: null,
  drawerKey: 0,
  open: (query?: string) =>
    set({
      isOpen: true,
      editingTaskId: null,
      initialQuery: query ?? null,
      drawerKey: get().drawerKey + 1,
    }),
  openForEdit: (taskId: string) =>
    set({
      isOpen: true,
      editingTaskId: taskId,
      initialQuery: null,
      drawerKey: get().drawerKey + 1,
    }),
  close: () => set({ isOpen: false, editingTaskId: null, initialQuery: null }),
}));
